import React from 'react';

interface HomepageProps {
  onNavigateToLogin: () => void;
}

export const Homepage: React.FC<HomepageProps> = ({ onNavigateToLogin }) => {
  return (
    <div className="min-h-screen crudo-gradient flex flex-col items-center justify-center">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-white mb-8">Crudo</h1>
        <button
          onClick={onNavigateToLogin}
          className="text-crudo-accent hover:text-blue-400 transition-colors text-lg"
        >
          Sign In
        </button>
      </div>
    </div>
  );
};